import React, { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import {
    AppBar, Box, Button, Drawer, IconButton, List, ListItem, ListItemButton,
    ListItemIcon, ListItemText, Toolbar, Typography,
} from '@mui/material';
import { AddBusiness, Dashboard, Logout, Menu as MenuIcon, QueryStats } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import { employeeSignOut } from '../../firebase/firebase-delegate';

const menuItems = [
    { name: 'All businesses', path: '/admin/superadmin', icon: <Dashboard /> },
    { name: 'Provision a business', path: '/admin/superadmin/provision', icon: <AddBusiness /> },
    { name: 'Analytics', path: '/admin/superadmin/analytics', icon: <QueryStats /> },
];

const SuperAdminLayout: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuth();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [signingOut, setSigningOut] = useState(false);

    const signOut = async () => {
        setSigningOut(true);
        try {
            await employeeSignOut();
        } finally {
            setSigningOut(false);
        }
    };

    return (
        <>
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton edge="start" color="inherit" aria-label="menu" onClick={() => setDrawerOpen(true)}>
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap sx={{ flexGrow: 1, minWidth: 0, cursor: 'pointer' }}
                        onClick={() => navigate('/admin/superadmin')}>
                        Super Admin
                    </Typography>
                    {user?.email && (
                        <Typography variant="body2" noWrap sx={{ mr: 2, display: { xs: 'none', sm: 'block' } }}>
                            {user.email}
                        </Typography>
                    )}
                    <Button
                        color="inherit"
                        startIcon={<Logout />}
                        disabled={signingOut}
                        onClick={() => void signOut()}
                        sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}
                    >
                        Sign out
                    </Button>
                </Toolbar>
            </AppBar>

            <Drawer anchor="left" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
                <List sx={{ width: 260 }}>
                    {menuItems.map((item) => (
                        <ListItem key={item.path} disablePadding>
                            <ListItemButton
                                selected={location.pathname === item.path}
                                onClick={() => {
                                    setDrawerOpen(false);
                                    navigate(item.path);
                                }}
                            >
                                <ListItemIcon>{item.icon}</ListItemIcon>
                                <ListItemText primary={item.name} />
                            </ListItemButton>
                        </ListItem>
                    ))}
                    <ListItem disablePadding>
                        <ListItemButton disabled={signingOut} onClick={() => void signOut()}>
                            <ListItemIcon><Logout /></ListItemIcon>
                            <ListItemText primary="Sign out" />
                        </ListItemButton>
                    </ListItem>
                </List>
            </Drawer>

            <Box sx={{ mt: 8 }}>
                <Outlet />
            </Box>
        </>
    );
};

export default SuperAdminLayout;
